module.exports = {
    baseUrl: 'http://172.30.3.18:8000/'
}